import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0025bd5c")

_pushScopeId("data-v-0025bd5c")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "field grid" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "ageInBusiness",
  class: "col-fixed wf-steps-label"
}, "Есть ли у вас опыт в бизнесе", -1)
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "field grid"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "isTourismBusiness",
  class: "col-fixed wf-steps-label"
}, "Связан ли ваши бизнес с туризмом", -1)
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "field grid"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "ageInTourism",
  class: "col-fixed wf-steps-label"
}, "Cколько лет вы в туризме", -1)
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  key: 0,
  class: "field grid"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "hasWorkingOffice",
  class: "col-fixed wf-steps-label"
}, "У вас есть действующий офис", -1)
const _hoisted_13 = { class: "col" }
const _hoisted_14 = {
  key: 0,
  class: "field grid"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "inLoveWithTourism",
  class: "col-fixed wf-steps-label"
}, "Вы любите путешествия", -1)
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "flex my-3" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "field grid" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", {
  for: "city",
  class: "col-fixed wf-steps-label"
}, "В каком городе вы планируете открыться", -1)
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "field grid" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  for: "population",
  class: "col-fixed wf-steps-label"
}, "Население вашего города", -1)
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "flex my-6" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "field grid" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  for: "monthsToPayOff",
  class: "col-fixed wf-steps-label"
}, "За сколько месяцев вы хотите полностью окупить вложения", -1)
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "flex my-6" }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "field grid" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", {
  for: "username",
  class: "col-fixed wf-steps-label"
}, "Имя", -1)
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "field grid" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", {
  for: "phone",
  class: "col-fixed wf-steps-label"
}, "Телефон", -1)
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "field grid" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "col-fixed wf-steps-label"
}, "Email", -1)
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "mt-0" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" я соглашаюсь ")
const _hoisted_43 = /*#__PURE__*/_createVNode("a", { href: "https://well.ru/about/acceptance_personal_data.php" }, " с политикой компании ООО «Велл» ", -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" по обработке моих персональных данных ")
const _hoisted_45 = { class: "flex my-6" }
const _hoisted_46 = { key: 4 }
const _hoisted_47 = { class: "" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Опрос завершен")
const _hoisted_49 = /*#__PURE__*/_createVNode("h3", { class: "mt-1 mb-0 text-normal" }, " Спасибо за прохождение опроса! ", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("h2", { class: "mt-1 mb-0" }, "Фин.показатели теперь Ваши!", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "mt-2 mb-0" }, " Наш менеджер свяжется с Вами в ближайшее время. ", -1)
const _hoisted_52 = { class: "flex my-6" }
const _hoisted_53 = { key: 5 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_InputMask = _resolveComponent("InputMask")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Message = _resolveComponent("Message")

  return (!_ctx.currentStep)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_SelectButton, {
              id: "bussinessExpirience",
              modelValue: _ctx.fields[0].hasBussinessExpirience,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fields[0].hasBussinessExpirience = $event)),
              options: _ctx.binaryOptions,
              optionValue: "value",
              optionLabel: "name",
              class: "mr-1 mb-1"
            }, null, 8, ["modelValue", "options"]),
            (_ctx.errors.hasBussinessExpirience)
              ? (_openBlock(), _createBlock(_component_InlineMessage, {
                  key: 0,
                  class: "error"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.errors.hasBussinessExpirience), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withId(() => [
            (_ctx.fields[0].hasBussinessExpirience === true)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_SelectButton, {
                      id: "isTourismBusiness",
                      modelValue: _ctx.fields[0].isTourismBusiness,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fields[0].isTourismBusiness = $event)),
                      options: _ctx.binaryOptions,
                      optionValue: "value",
                      optionLabel: "name",
                      class: "mr-1 mb-1"
                    }, null, 8, ["modelValue", "options"]),
                    (_ctx.errors.isTourismBusiness)
                      ? (_openBlock(), _createBlock(_component_InlineMessage, {
                          key: 0,
                          class: "error"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.errors.isTourismBusiness), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withId(() => [
            (_ctx.fields[0].hasBussinessExpirience === true && _ctx.fields[0].isTourismBusiness === true)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_InputText, {
                      id: "ageInTourism",
                      modelValue: _ctx.fields[0].ageInTourism,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fields[0].ageInTourism = $event)),
                      class: ["mr-1 mb-1", { 'invalid': _ctx.errors.ageInTourism }]
                    }, null, 8, ["modelValue", "class"]),
                    (_ctx.errors.ageInTourism)
                      ? (_openBlock(), _createBlock(_component_InlineMessage, {
                          key: 0,
                          class: "error"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.errors.ageInTourism), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withId(() => [
            (_ctx.fields[0].hasBussinessExpirience === true && _ctx.fields[0].isTourismBusiness === true)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_SelectButton, {
                      id: "hasWorkingOffice",
                      modelValue: _ctx.fields[0].hasWorkingOffice,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fields[0].hasWorkingOffice = $event)),
                      options: _ctx.binaryOptions,
                      optionValue: "value",
                      optionLabel: "name",
                      class: "mr-1 mb-1"
                    }, null, 8, ["modelValue", "options"]),
                    (_ctx.errors.hasWorkingOffice)
                      ? (_openBlock(), _createBlock(_component_InlineMessage, {
                          key: 0,
                          class: "error"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.errors.hasWorkingOffice), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withId(() => [
            (_ctx.fields[0].hasBussinessExpirience === false)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_SelectButton, {
                      id: "inLoveWithTourism",
                      modelValue: _ctx.fields[0].inLoveWithTourism,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fields[0].inLoveWithTourism = $event)),
                      options: _ctx.binaryOptions,
                      optionValue: "value",
                      optionLabel: "name",
                      class: "mr-1 mb-1"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Button, {
            style: {"z-index":"2"},
            label: "Следующий шаг",
            icon: "pi pi-steforward",
            class: "p-button-lg shadow-8 p-button-warning",
            onClick: _cache[6] || (_cache[6] = () => _ctx.goToStep('city'))
          })
        ])
      ]))
    : (_ctx.currentStep === 'city')
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_InputText, {
                id: "ageInBusiness",
                modelValue: _ctx.fields[1].city,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.fields[1].city = $event)),
                type: "text",
                class: ["mr-1 mb-1", { 'invalid': _ctx.errors.city }]
              }, null, 8, ["modelValue", "class"]),
              (_ctx.errors.city)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 0,
                    class: "error"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.errors.city), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_InputText, {
                id: "population",
                modelValue: _ctx.fields[1].population,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fields[1].population = $event)),
                type: "text",
                class: ["mr-1 mb-1", { 'invalid': _ctx.errors.population }]
              }, null, 8, ["modelValue", "class"]),
              (_ctx.errors.population)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 0,
                    class: "error"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.errors.population), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_Button, {
              style: {"z-index":"2"},
              label: "Назад",
              icon: "pi pi-stebackward",
              class: "p-button-lg shadow-8 mr-1 p-button-outlined",
              onClick: _cache[9] || (_cache[9] = () => _ctx.router.push({ path: '/steps/' }))
            }),
            _createVNode(_component_Button, {
              style: {"z-index":"2"},
              label: "Следующий шаг",
              icon: "pi pi-steforward",
              class: "p-button-lg shadow-8 p-button-warning",
              onClick: _cache[10] || (_cache[10] = () => _ctx.goToStep('cost'))
            })
          ])
        ]))
      : (_ctx.currentStep === 'cost')
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", _hoisted_29, [
                _createVNode(_component_InputText, {
                  id: "monthsToPayOff",
                  modelValue: _ctx.fields[2].monthsToPayOff,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.fields[2].monthsToPayOff = $event)),
                  type: "text",
                  class: ["mr-1 mb-1", { 'invalid': _ctx.errors.monthsToPayOff }]
                }, null, 8, ["modelValue", "class"]),
                (_ctx.errors.monthsToPayOff)
                  ? (_openBlock(), _createBlock(_component_InlineMessage, {
                      key: 0,
                      class: "error"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.errors.monthsToPayOff), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_Button, {
                style: {"z-index":"2"},
                label: "Назад",
                icon: "pi pi-stebackward",
                class: "p-button-lg shadow-8 mr-1 p-button-outlined",
                onClick: _cache[12] || (_cache[12] = () => _ctx.router.push({ path: '/steps/city' }))
              }),
              _createVNode(_component_Button, {
                style: {"z-index":"2"},
                label: "Следующий шаг",
                icon: "pi pi-steforward",
                class: "p-button-lg shadow-8 p-button-warning",
                onClick: _cache[13] || (_cache[13] = () => _ctx.goToStep('contacts'))
              })
            ])
          ]))
        : (_ctx.currentStep === 'contacts')
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("div", _hoisted_34, [
                  _createVNode(_component_InputText, {
                    id: "username",
                    modelValue: _ctx.fields[3].username,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.fields[3].username = $event)),
                    type: "text",
                    class: ["mr-1 mb-1", { 'invalid': _ctx.errors.username }]
                  }, null, 8, ["modelValue", "class"]),
                  (_ctx.errors.username)
                    ? (_openBlock(), _createBlock(_component_InlineMessage, {
                        key: 0,
                        class: "error"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.errors.username), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode("div", _hoisted_37, [
                  _createVNode(_component_InputMask, {
                    id: "phone",
                    modelValue: _ctx.fields[3].phone,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.fields[3].phone = $event)),
                    class: ["mr-1 mb-1", { 'invalid': _ctx.errors.phone }],
                    mask: "+7 (999) 999-9999"
                  }, null, 8, ["modelValue", "class"]),
                  (_ctx.errors.phone)
                    ? (_openBlock(), _createBlock(_component_InlineMessage, {
                        key: 0,
                        class: "error"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.errors.phone), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode(_component_InputText, {
                    id: "email",
                    modelValue: _ctx.fields[3].email,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.fields[3].email = $event)),
                    type: "text",
                    class: ["mr-1 mb-1", { 'invalid': _ctx.errors.email }]
                  }, null, 8, ["modelValue", "class"]),
                  (_ctx.errors.email)
                    ? (_openBlock(), _createBlock(_component_InlineMessage, {
                        key: 0,
                        class: "error"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.errors.email), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("p", _hoisted_41, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.fields[3].isAgreementChecked,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.fields[3].isAgreementChecked = $event)),
                  binary: true,
                  class: ["mr-1", { 'invalid': _ctx.errors.isAgreementChecked }]
                }, null, 8, ["modelValue", "class"]),
                _hoisted_42,
                _hoisted_43,
                _hoisted_44
              ]),
              (_ctx.errors.isAgreementChecked)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 0,
                    class: "error"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.errors.isAgreementChecked), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_45, [
                _createVNode(_component_Button, {
                  style: {"z-index":"2"},
                  label: "Назад",
                  icon: "pi pi-stebackward",
                  class: "p-button-lg shadow-8 mr-1 p-button-outlined",
                  onClick: _cache[18] || (_cache[18] = () => _ctx.router.push({ path: '/steps/cost' }))
                }),
                _createVNode(_component_Button, {
                  style: {"z-index":"2"},
                  label: "Следующий шаг",
                  icon: "pi pi-steforward",
                  class: "p-button-lg shadow-8 p-button-warning",
                  onClick: _cache[19] || (_cache[19] = () => _ctx.goToStep('success'))
                })
              ])
            ]))
          : (_ctx.currentStep === 'success')
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode(_component_Message, { severity: "success" }, {
                    default: _withId(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  }),
                  _hoisted_49,
                  _hoisted_50,
                  _hoisted_51
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode(_component_Button, {
                    label: "Скачать фин.показатели",
                    icon: "pi pi-download",
                    class: "mr-1 p-button-lg shadow-8 p-button-warning",
                    onClick: _ctx.downloadPresentation
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    style: {"z-index":"2"},
                    label: "Пройти заново",
                    icon: "pi pi-stebackward",
                    class: "p-button-lg shadow-8 mr-1 p-button-outlined",
                    onClick: _cache[20] || (_cache[20] = () => _ctx.router.push({ path: '/' }))
                  })
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_53, "Неверный шаг!"))
})